import { PriceGroupModel } from "../../../mvcapi/models/buyticket";
import { useMemObjCache } from "./use-mem-cache";

export function useMVCPriceGroupModelsCache(priceIds?: number[]): [ PriceGroupModel[], (priceInfosToAdd: PriceGroupModel[]) => void, Map<number, PriceGroupModel>] {
    const cache = useMemObjCache<number, PriceGroupModel>("priceInfoById");

    let priceInfos = []; 
    if(priceIds)
        priceInfos = priceIds.map(id => cache.get(id)).filter(p => p !== undefined);
    
    //console.log("Price group cache accessed : ", priceIds, priceInfos);

    const putPricesInfoInCache = (priceInfosToAdd: PriceGroupModel[]) => {
        if(priceInfosToAdd && priceInfosToAdd.length > 0) {
            //console.log("Price group model cache updated : ", priceInfosToAdd,  cache);
            priceInfosToAdd.forEach(p => cache.set(p.PriceID, p));
        }
    };

    return [ priceInfos, putPricesInfoInCache, cache ];
}

export function useMVCPriceGroupModelCache(priceIds: number) {
    const [priceGroup, putPricesInfoInCache] = useMVCPriceGroupModelsCache([priceIds]);

    return [ priceGroup, putPricesInfoInCache ];
}